import type { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";
import { Image } from "../../../fe-ui/atoms/Image";

interface Props {
  body?: string;
  children?: ReactNode;
  image1?: string;
  image2?: string;
  image2Alt?: string;
  image2Height?: string;
  image2Width?: string;
  isCentered?: boolean;
  title?: string;
  variant?: 'left' | 'right';
}

export const LandingZigZag = ({
  body,
  children,
  title,
  image1,
  image2,
  image2Alt,
  image2Height,
  image2Width,
  isCentered = false,
  variant = 'left',
}: Props) => {
  return (
    <Stack
      alignItems="center"
      direction={{ xs: "column", md: variant === 'left' ? "row" : "row-reverse" }}
      spacing={{ xs: 2, md: 8 }}
      sx={{ py: 5 }}
    >
      <Stack
        direction={"column"}
        spacing={2}
        sx={[
          isCentered && { textAlign: 'center' },
          { marginBlockEnd: { xs: 4 } }
        ]}
      >
        {title ? <Typography variant="h3">{title}</Typography> : null}
        {body ? <Typography variant="bodyLg">{body}</Typography> : null}
        {children}
        {image2 ? <Image
          alt={image2Alt}
          draggable={false}
          src={image2}
          sx={{ maxHeight: image2Height, maxWidth: image2Width }}
        /> : null}
      </Stack>
      {image1 ? <Image
        alt={title}
        draggable={false}
        src={image1}
        sx={{
          alignSelf: { xs: 'center', md: 'flex-end' },
          flexShrink: 0,
          flexBasis: { md: '50%', lg: '40%' },
          lineHeight: 0,
        }}
      /> : null}
    </Stack>
  );
};
